import moment from "moment";
import { EventEntry, Fee } from "../../models";

/**
 * Function to check if a fee should be applied due to the entry submission happening after the fee's start date and time.
 * Returns true if the fee should be included
 * Returns false if the fee should NOT be included
 * 
 * @param fee 
 * @param entry 
 * @returns boolean
 */
export function isAfterEventFeeStartDate(fee: Fee, entry?: EventEntry): boolean {
    if (fee.isStartedOnEntryDate) {
        if (fee.startDate) {
            const startDate: string = fee.startDate;
            const startTime = fee.startTime || "23:59:59.999";
            let entrySubmissionDate: string = entry?.submittedOn ? moment(entry?.submittedOn).format("YYYY-MM-DD") : "";
            let entrySubmissionTime: string = entry?.submittedOn ? moment(entry?.submittedOn).format("HH:mm:ss.sss") : "";
            
            if (!entrySubmissionDate || entrySubmissionDate === "") {
                // Entry has not been submitted yet. Use today's date as check
                entrySubmissionDate = moment(new Date()).format("YYYY-MM-DD");
                entrySubmissionTime = moment(new Date()).format("HH:mm:ss.sss");
            }

            const checkIsBeforeFeeStartDate = (entrySubmissionDate !== startDate && entrySubmissionDate < startDate);
            const checkIsSameDateBeforeFeeStartTime = (entrySubmissionDate === startDate && entrySubmissionTime < startTime);

            // Check if the implementation date has been hit, and check if the date is the same, but it's not implementation time yet.
            if (checkIsBeforeFeeStartDate || checkIsSameDateBeforeFeeStartTime) {
                // Haven't hit the fee implementation datetime yet, so do not include the fee
                return false;
            } else {
                return true;
            }
        }
    }

    return false;
}